import { FormLayout } from "@careinfo/layout";
import React from "react";
import { useForm } from "react-hook-form";
import Hubform from "./Hubform";

const EditHub = (props: any) => {
  const { handleEdit, isLoading, data } = props;
  const {
    handleSubmit,
    setError,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...data,
    },
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <Hubform register={register} errors={errors} />
    </FormLayout>
  );
};

export default EditHub;
